<template>
	<section>
		<img v-bind:src="'img/' + img" alt="Bisa Cek" class="mt-5 mx-auto d-block img-fluid">
		<p class="text-center">{{ title }}</p>
		<slot name="buttonAdd"></slot>
		<img src="img/group-311.png" alt="Bisa Cek" class="mt-5 hide-on-web" style="width: 30%">
	</section>
</template>

<script>
export default {
	name: 'NoList',
	props: ['title', 'btnText'],
	computed: {
		img: function(){
			switch (this.$route.name) {
				case 'ExpeditionIndex':
					return 'group-7-perjalanan.png'	
				case 'DeliveryIndex':
					return 'group-7-pengiriman.png'	
				case 'ContactIndex':
					return 'group-7-kontak.png'		
				case 'PriceIndex':
					return 'group-7-pengiriman.png'
				case 'DriverIndex':
					return 'group-7-driver.png'
				case 'DeviceIndex':
					return 'group-7-device.png'
				case 'VehicleIndex':
					return 'group-7-kendaraan.png'
			
				default:
					return ''
			}
		}
	}
}
</script>